export const BRAND_SETTINGS = {
    ADD_SUBTEAM_BTN: "add-subteam-btn",
    SUBTEAM_NAME_INPUT: "subteam-name",
    SUBTEAM_EMAIL_INPUT: "subteam-email",
    UPDATE_SETTINGS_BTN: "update-settings-btn",
    REMOVE_SUBTEAM_BTN: "remove-subteam",
    SUBTEAM_CONTAINER: "subteam_container",
    SUBTEAM_ENTRY: "subteam-entry",
    SUBTEAM_EMAIL_CONTAINER: "subteam-email-container",
};
